<template>
  <!--选择当前页  选择全部-->
  <yxt-table-column
    fixed="left"
    width="18"
    align="right"
    clear-padding="left-right">
    <template slot="header">
      <yxt-dropdown trigger="click" @command="handleCommand">
        <span> </span>
        <yxt-dropdown-menu slot="dropdown">
          <yxt-dropdown-item command="current">{{ $t('pc_biz_enroll_select_current_page' /* 选择本页*/) }}</yxt-dropdown-item>
          <yxt-dropdown-item command="all">{{ $t('pc_biz_enroll_select_all') /* 选择全部 */ }}</yxt-dropdown-item>
          <yxt-dropdown-item command="delAll">{{ $t('pc_biz_enroll_clear_all') /*  清空所选*/ }}</yxt-dropdown-item>
        </yxt-dropdown-menu>
      </yxt-dropdown>
    </template>
  </yxt-table-column>
</template>

<script>
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  TableColumn } from 'yxt-pc';
export default {
  name: 'SelectPartOrAll',
  components: {
    YxtDropdown: Dropdown,
    YxtDropdownMenu: DropdownMenu,
    YxtDropdownItem: DropdownItem,
    YxtTableColumn: TableColumn
  },
  methods: {
    handleCommand(command) {
      this.$emit('handleCommand', command);
    }
  }
};
</script>
